import { Component, Vue, Watch } from 'vue-property-decorator';
import { IShowing } from '../../../models/showing';
import ShowingsTableExpand from './ExpandRow/expand.vue';
import * as T_T from 'cryface';
import { ShowingsListDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.list.delegate';
import { ShowingsRestfulDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.restful.delegate';

@Component
export default class ShowingsTable extends Vue {
   public title: string = 'ShowingsTable';
   public listDelegate = new ShowingsListDelegate();
   public restFulDelegate = new ShowingsRestfulDelegate();

   public editIndex = -1;
   public editData: IShowing = {
      id: '',
      listing_id: '',
      status: '',
      visit_date: '',
      address: '',
      listing_agent_one: '',
      listing_agent_two: '',
      showing_agent: '',
      created_date: ''
   };

   public isSelected: boolean = false;
   public selected: any[] = [];

   public columnsMain: any[] = [
      {
         type: 'selection',
         width: 60,
         align: 'center'
      },
      {
         type: 'expand',
         width: 50,
         render: (h: any, params: any) => {
            return h(ShowingsTableExpand, {
               props: {
                  row: params.row
               }
            });
         }
      },
      {
         title: 'Status',
         slot: 'status',
         width: 150,
         // render: (h: any, params: any) => {
         //    return h('div', [
         //       h('strong', params.row.status)
         //    ]);
         // }
      },
      {
         title: 'Visit Date ',
         slot: 'visit_date',
         width: 150,
         sortable: true,
      },
      {
         title: 'Address',
         slot: 'address',
         width: 250
      },
      {
         title: 'L-Agent1',
         slot: 'listing_agent_one',
         width: 140,
      },
      {
         title: 'L-Agent2',
         slot: 'listing_agent_two',
         width: 140,
      },
      {
         title: 'S-Agent',
         slot: 'showing_agent',
         width: 140,
      },
      {
         title: 'Created Date ',
         slot: 'created_date',
         width: 150,
         sortable: true,
      },
      {
         title: 'Action',
         slot: 'action',
         width: 300,
      }
      // {
      //    title: 'Action',
      //    key: 'action',
      //    render: (h: any, params: any) => {
      //       return h('div', [
      //          h('Button', {
      //             props: {
      //                type: 'primary',
      //                size: 'small'
      //             },
      //             style: {
      //                marginRight: '5px'
      //             },
      //             on: {
      //                click: () => {
      //                   this.handleView(params.index);
      //                }
      //             }
      //          }, 'View'),
      //          h('Button', {
      //             props: {
      //                type: 'error',
      //                size: 'small'
      //             },
      //             on: {
      //                click: () => {
      //                }
      //             }
      //          }, 'Cancel')
      //       ]);
      //    }
      // }
   ];

   public data: IShowing[] = [];
   public listupdateTimestamp = new Date();

   public reset = true;

   public totalItems = 100;

   public current = 1;

   // lifecycle hook
   public async created() {
      this.$store.commit('showingStartFetching');
      const result = await this.listDelegate.searchShowings(1, 10);
      this.totalItems = this.listDelegate.TotalItems;
      this.current = this.listDelegate.CurrentPage;
      if (result === 1) {
         this.$store.commit('updateShowings');
      } else {
         this.$Notice.error(
            {
               title: 'Error',
               desc: `Failed To Get Data`
            }
         );
      }
      this.$store.commit('showingEndFetching');
   }

   public reload() {
      this.reset = false;
      this.$nextTick(() => (this.reset = true));
   }

   @Watch('$store.state.showings.list', { deep: true, immediate: true })
   public onDataChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.data = val.data;
         this.totalItems = val.total;
         this.current = val.currentPage;
         this.listupdateTimestamp = val.timestamp;
         this.reload();
      }
   }

   public handleModify(row: IShowing, index: number) {
      this.editData.status = row.status;
      this.editData.visit_date = row.visit_date;
      this.editData.address = row.address;
      this.editData.listing_agent_one = row.listing_agent_one;
      this.editData.listing_agent_two = row.listing_agent_two;
      this.editData.showing_agent = row.showing_agent;
      this.editData.created_date = row.created_date;
      this.editData.listing_id = row.listing_id;
      this.editData.id = row.id;
      this.editIndex = index;
   }

   public async handleShowingConfirm(row: any, index: number) {
      this.$store.commit('showingStartFetching');
      await this.restFulDelegate.confirmShowing([row.id]);
      await this.listDelegate.searchShowings(1);
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
      this.$Notice.success(
         {
            title: 'Confirmed',
            desc: `Showing Confirmed`
         }
      );
   }

   public async handleShowingCancel(row: any, index: number) {
      this.$store.commit('showingStartFetching');
      await this.restFulDelegate.cancelShowing([row.id]);
      await this.listDelegate.searchShowings(1);
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
      this.$Notice.warning(
         {
            title: 'Cancelled',
            desc: `Showing Cancelled`
         }
      );
   }

   public async handleSave(index: number) {
      this.$store.commit('showingStartFetching');
      this.editIndex = -1;
      await this.restFulDelegate.updateShowing(this.editData.id, this.editData);
      await this.listDelegate.searchShowings(1);
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
      this.$Notice.success(
         {
            title: 'Succeed',
            desc: `Saved Changes For: <br> ${this.editData.address}`
         }
      );
   }

   public handleSelectAll() {
      this.isSelected = true;
      const selection: any = this.$refs.selection;
      for (let i = 0; i < selection.data.length; i++) {
         this.selected.push(selection.data[i].id);
      }
      selection.selectAll(this.isSelected);
   }

   public async handleShowingConfirmAll() {
      this.$store.commit('showingStartFetching');
      const selection: any = this.$refs.selection;
      await this.restFulDelegate.confirmShowing(this.selected);
      await this.listDelegate.searchShowings(1);
      this.isSelected = false;
      selection.selectAll(this.isSelected);
      this.selected = [];
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
      this.$Notice.success(
         {
            title: 'Confirmed',
            desc: `Showings Confirmed.`
         }
      );
   }

   public async handleShowingCancelAll() {
      this.$store.commit('showingStartFetching');
      const selection: any = this.$refs.selection;
      await this.restFulDelegate.cancelShowing(this.selected);
      await this.listDelegate.searchShowings(1);
      this.isSelected = false;
      selection.selectAll(this.isSelected);
      this.selected = [];
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
      this.$Notice.success(
         {
            title: 'Cancelled',
            desc: `Showings Cancelled.`
         }
      );
   }

   public handleCancelSelect() {
      this.isSelected = false;
      const selection: any = this.$refs.selection;
      this.selected = [];
      selection.selectAll(false);
   }

   public onSelect(selectedData: any, value: any) {
      // if (this.selected.indexOf(this.data.indexOf(selectedData)) !== -1) {
      //    this.selected.splice(this.selected.indexOf(this.data.indexOf(selectedData)), 1);
      // } else {
      //    this.selected.push(this.data.indexOf(selectedData));
      // }
      // if (this.selected.length === 0) {
      //    const selection: any = this.$refs.selection;
      //    selection.selectAll(false);
      // } else {
      //    this.isSelected = true;
      // }
      // console.log(selectedData);
      this.selected.push(value.id);
      this.isSelected = true;
   }

   public onSelectCancel(selectedData: any, value: any) {
      this.selected.splice(this.selected.indexOf(value.id), 1);
      if (this.selected.length === 0) {
         this.isSelected = false;
      }
   }

   public destroyed() {
      this.restFulDelegate.clearData();
      this.listDelegate.clearData();
   }

   public async onPageChange(pageNum: number) {
      this.$store.commit('showingStartFetching');
      const result = await this.listDelegate.searchShowings(pageNum, 10);
      if (result === 1) {
         this.$store.commit('updateShowings');
      } else {
         this.$Notice.error(
            {
               title: 'Error',
               desc: `Failed To Get Data`
            }
         );
      }
      this.$store.commit('showingEndFetching');
   }
}
